import React, { useState } from 'react'
import { jsx, Box, Heading, Grid, Button,Text } from 'theme-ui';
import { ethers } from "ethers";
import { usePoller } from "../hooks";

export default function Balance(props) {

  const [dollarMode, setDollarMode] = useState(true);
  const [balance, setBalance] = useState();
  usePoller(async ()=>{
    if(props.address && props.provider){
      try{
        const newBalance = await props.provider.getBalance(props.address)
        setBalance(newBalance)
      }catch(e){
        console.log(e)
      }
    }
  },props.pollTime?props.pollTime:1999)

  let floatBalance = parseFloat("0.00")

  let usingBalance = balance

  if(typeof props.balance != "undefined"){
    usingBalance = props.balance
  }

  if(usingBalance){
    let etherBalance = ethers.utils.formatEther(usingBalance)
    parseFloat(etherBalance).toFixed(2)
    floatBalance =parseFloat(etherBalance)
  }

  /* let displayBalance = "Ξ"+ floatBalance.toFixed(4) */
  let displayBalance = "Ξ"+ floatBalance.toFixed(4)

  if(props.dollarMultiplier && dollarMode){
    displayBalance = "$"+(floatBalance*props.dollarMultiplier).toFixed(2)
  }

  return (
    <Text
    onClick={()=>{setDollarMode(!dollarMode)}}
    as="span"
    sx={{
      fontSize: 'fs1',
      maxWidth: 320,
      mx: 's',
      textAlign: 'center',
      fontFamily:'sans',
      display: [ 'inline-block' ]
    }}
    
    className="tsf xas interactive_link"
    >
    {displayBalance}
    </Text>


  );
}
